<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              We ensure all students have the opportunity to pay their full tuition through financial aid, scholarship, and or student aid programmes.
              <br>
              &lt;!&ndash;<span class="uk-text-small uk-text-muted">
                  Late Applicant will be considered but will attract late fees.
                </span>&ndash;&gt;


            </p>
          </div>
        </div>-->
        <div class="uk-padding uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading">Tuition & Fees</h1>
            <h4 class="uk-heading-divider uk-text-center specHeading" style="color: rgb(3, 56, 96) !important;">Changes, if made, will be effective August 1 of the ensuing year.
              <br>
              <span class="uk-text-muted">All fees are subject to change by the Northern Caribbean University Board of Trustees.</span></h4>
            <br>
            <div uk-grid>
              <div class="uk-width-1-1@m ">
                <div class="uk-child-width-1-2@m" uk-grid>
                  <div>
                    <div class="uk-tile uk-tile-muted uk-text-center">
                      <a href="/Tuition&Fees2024-2025.pdf" target="_blank" class="uk-button-link ">
                        <h3 class="uk-heading-bullet  specHeading uk-button-link">Tuition Fees <span class=" uk-text-muted">2024 - 2025</span>
                          <br>
                          <span class=" uk-text-bold uk-margin-left">Click here to view</span><br>
                          <span uk-icon="icon: download; ratio: 2"></span>
                        </h3>
                      </a>
                    </div>
                  </div>

                  <div class="uk-visible@m">
                    <img src="../assets/tuition_pay.jpg" alt="">
                  </div>
                </div>

              </div>
              <div class="uk-width-1-1">
                <div>
                  <h3 class="uk-heading-bullet uk-text-muted specHeading">Late Registration Fees</h3>
                  <p class=" uk-text-muted">
                    Students who do not complete registration during the registration period will be charged $1000 on the
                    first day and $1000 each additional day until two weeks after the semester has begun.

                  </p>
                  <h3 class="uk-heading-bullet specHeading uk-text-muted">Fee Liability</h3>

                  <h5 class="uk-heading-bullet specHeading uk-text-muted uk-margin-remove-top">Breach of Contract</h5>

                  <p class=" uk-text-muted">
                    Students will be registered for courses as their sources of funding dictate. As a result, students are
                    liable for all fees associated with all courses for which they are registered at the end of the add/drop
                    period. If fees are not paid in full by the end of the contract period, all courses will be subject to
                    cancellation and monies paid to the University will be lost.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-padding  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h2 class="uk-heading-line uk-text-center specHeading">Auxiliary Fees </h2>

            <div class="uk-child-width-1-2@m" uk-grid>

              <div  class="uk-margin-remove-top">
                <br>


                <h3 class="uk-heading-bullet  specHeading">Pre-Acceptance Security Deposit</h3>
                <p class=" uk-text-muted">
                  All new students are required to make a cash deposit before receiving their letter of acceptance.
                  The deposit is held as security until students sever their connection with the university, at which time they receive a full refund, provided no outstanding bills remain.
                  <br><br>Details regarding deposits are available from the Financial Affairs.

                </p>

              </div>
              <div class="uk-margin-remove-top">
                <br>
                <h3 class="uk-heading-bullet  specHeading">Registration Fees</h3>


                <p class=" uk-text-primary">
                  <span class="uk-text-muted">Undergraduate</span>: Local Students - JMD$1000, International Students US$55, West Indies Union - US $30.
                  <br>
                  <span class="uk-text-muted">Graduate</span>: Post-graduate Diploma & Masters: Local - J$2,500, International: US$30.00, Doctoral: Local Students - J$3,500.00, International: US$50.00
                  <br>
                  <span class="uk-text-small uk-text-muted">This is a one-time non-refundable fee paid by an individual who applies for
                      admission to the University. A student is required to pay this fee when he/she applies for admission.
                </span>

                </p>

              </div>

              <div class="uk-width-1-2@m uk-margin-remove-top">
                <br>
                <h3 class="uk-heading-bullet  specHeading">Graduation Related Fees</h3>
                <p class=" uk-text-muted">
                  A rental charge is applicable to students in undergraduate or masters programmes, who rent academic regalia provided by the university for graduation.
                  If not returned within the prescribed time, it attracts a penalty of $500 per day.
                  <br>
                  Doctoral regalia has to be ordered by the candidate and belongs to them; the University does not rent doctoral regalia.
                  <br>
                  Graduation class fees are set by the class executive of each graduating class. These fees are not charged by the university.
                </p>




                <br><br>
              </div>

              <div class="uk-width-1-2@m uk-margin-remove-top">
                <br>
                <h3 class="uk-heading-bullet  specHeading">Mid-Semester Withdrawal</h3>
                <p class=" uk-text-muted">
                A student who begins registration, but fails to complete it, and then withdraws, will be charged a handling fee equivalent to the general fee.
                  When a student withdraws during a semester, the semester's charge for boarding becomes due and payable.
                  Refund of deposits is issued only after a final statement for the student is available.
                  Payment should therefore be expected 30 to 45 days after the student leaves the University.
                  <br>The sum to be refunded will be calculated only on Tuition and applicable lab changes based on the following:

                </p>

                <ul class="uk-list uk-list-bullet uk-text-muted uk-text-small uk-margin-remove-top">
                  <li>

                    Up to two weeks 90% refund
                  </li>
                  <li>

                    Two to four weeks 60% refund
                  </li>
                  <li>
                    Over four weeks No refund
                  </li>
                </ul>



              </div>


            </div>
          </div>
        </div>

        <div class="uk-padding uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h2 class="uk-heading-line uk-text-center specHeading">Where to Pay </h2>

            <div uk-grid>
                <div class="uk-child-width-1-2@m" uk-grid>
                  <div>
                    <img src="../assets/tuition_pay1.jpg" alt="" class="uk-responsive-height uk-responsive-width uk-align-center">
                  </div>
                  <div>
                    <ul class="uk-list uk-list-bullet ">
                      <li>
                        Any Paymaster or Bill Express
                      </li>
                      <li>
                        Any Bank of Nova Scotia (BNS) branch, or Scotia online bill payment
                      </li>
                      <li>
                        Any National Commercial Bank (NCB) branch
                      </li>
                      <li>
                        The NCU Cashier (8:15-4:00 Mon-Thur. & Fri. 8:15-1:00). Payments are accepted using only bank cards or manager’s cheques or cashier’s cheques. Cheques should be made payable to Northern Caribbean University.
                      </li>
                      <li>
                      Payments may also be made online through the university’s site.

                      </li>
                      <li>
                        If accounts are being settled by mail, following the guidelines on cheques, letters should be addressed to the Director, Student Finance, Northern Caribbean University, Manchester Road, Mandeville, Jamaica WI.
                      </li>
                    </ul>
                  </div>


                </div>
            </div>
          </div>
        </div>

        <div class="uk-padding uk-background-secondary uk-light uk-margin-remove-top">
          <div class="uk-container uk-container-large">

            <div class="uk-child-width-1-2@m uk-child-width-1-4@l" uk-grid>

              <div>
                <h4 class="uk-heading-bullet specHeading">Sibling Discount</h4>

                <p class="">
                  A discount of five per cent (5%) of the tuition charges is given where the expenses for two children
                  from one family are being paid by the same person, and ten per cent (10%) is allowed for three or more
                  children. Discounts are not retroactive, and will be granted only to those whose accounts are kept in balance.
                </p>
              </div>
              <div>
                <h4 class="uk-heading-bullet specHeading">Rent Deposit</h4>

                <p class="">
                  In addition to its residence halls the University has a limited number of furnished apartments, which
                  are available to married students, and only by the special exemption the Vice President for Finance &
                  Industries to matured unmarried students. The University also has access to unfurnished one-bedroom studio
                  apartments and two-bedroom flats, which are privately owned, and whose rates are set by the landlord involved.
                  The same policy applies as regards married and unmarried students. Rent agreements and deposits must be signed and paid before any apartment is assigned.
                </p>
              </div>

              <div>
                <h4 class="uk-heading-bullet specHeading">Cash Withdrawals & Refunds</h4>
                <p class="">
                Cash paid in advance on students' accounts may not be withdrawn without the written permission of the individual
                  or organization which originally made the payments. It is expected that such withdrawals will be rare, and that
                  financial sponsors will provide students with allowances for incidental personal expenses. However, bona fide
                  emergencies will be given consideration when accounts show consistent credit balances.
                </p>
              </div>

              <div>
                <h4 class="uk-heading-bullet  specHeading">I.D. Card Replacement Fees</h4>
                <p class=" uk-text-muted">
                  Each student is issued an identification card, which certifies that he/she is enrolled as a student at the University.
                  <br>
                  There is no charge for the original card. A non-refundable fee of $1,000 is required for replacement.
                  <br>
                  This identification card bears the student's photograph and is required for registration, all financial transactions,
                  library privileges, entrance to campus activities and other identification purposes.
                </p>
              </div>

              <div></div>

            </div>
          </div>
        </div>

        <div class="uk-padding  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h2 class="uk-heading-line uk-text-center specHeading">Other Fees </h2>


              <div class="uk-child-width-1-3@m" uk-grid>
                <div class="uk-padding">
                  <h3 class="uk-heading-bullet specHeading">General Fees</h3>
                  <p class="">
                    The general usage of facilities on campus including the library and
                    computers in designated areas, including online student services
                  </p>
                </div>
                <div class="uk-padding">
                  <h3 class="uk-heading-bullet specHeading">Music</h3>
                  <p class="">
                    Students taking a major or minor in Music and taking Applied Music are charged
                    according to a special schedule. There is no refund of fees if music lessons are dropped
                    after two weeks or four lessons, in any semester, except in cases of prolonged illness.
                    Lessons lost because of a student's irregularity in attendance may not be made up
                  </p>
                </div>
                <div class="uk-padding">
                  <h3 class="uk-heading-bullet specHeading">Laboratories</h3>
                  <p class="">
                    Laboratories are required in the following disciplines and therefore attract fees each
                    semester:
                  </p>
                  <ul class="uk-list uk-list-bullet uk-text-small">
                    <li class="uk-margin-remove-top">Biology</li>
                    <li class="uk-margin-remove-top">Chemistry</li>
                    <li class="uk-margin-remove-top">Medical Technology</li>
                    <li class="uk-margin-remove-top">Physics</li>
                    <li class="uk-margin-remove-top">Nutrition and Hospitality Management</li>
                    <li class="uk-margin-remove-top">Teacher Education External examination - (yearly fee) - JBTE diploma</li>
                    <li class="uk-margin-remove-top">Mass Communication</li>
                    <li class="uk-margin-remove-top">Information Science</li>
                    <li class="uk-margin-remove-top">Nursing</li>
                    <li class="uk-margin-remove-top">Dental Hygiene</li>
                  </ul>
                </div>
              </div>

          </div>
        </div>

        <div class="uk-padding uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <p class="uk-text-small uk-text-muted">
              Northern Caribbean University reserves the right to increase the charges listed herein, or to add new fees whenever such increases or additions become necessary. All fees and room rents are for the academic year 2016-2017, and are subject to change by action of the University Board of Trustees. The listing of any fee or incidental charges in this catalog does not constitute a contract between the University and the student. As a condition of registration, each student must pay the appropriate fee(s) in effect at the time of registration.

              <br><br>

              The Admissions Office determines a student's residency classification for fee-paying purposes. If a student is incorrectly classified, he/she will be billed for additional fees owed or refunded overpaid fees.
              <br><br>
              The University assumes no responsibility for monies lost through the mail.

              For further information please contact the Student Finance Department at:
              <br>

              <br>
              Telephone: (876) 962-2204 or 963-7223-8
              <br>
              Fax number: (876) 962-0075 or 962-8552
              <br>
              Email address: studentfinance@ncu.edu.jm
            </p>
          </div>
        </div>

      </div>

    </div>
  </transition>
</template>

<script>
    export default {
        name: "tuitionfees",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Tuition Fees',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Tuition Fees at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){


    h3,h2{
      font-size: 1.2em !important;
    }
    h1{
      font-size: 1.5em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }


  }
</style>
